// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1WWJT","title":"Info_title__3_LD7","selects":"Info_selects__1kMxH","requiredAsterisk":"Info_requiredAsterisk__230NK"};